import {getDataObject} from '../helpers';
import api from '@/api';

const state = {
  submissionResponse: {
    status: 0,
    data: {}
  }
};

const getters = {
  submissionResponse: state => state.submissionResponse
};

const actions = {
  // Send the Completed Form to the API
  saveSubmission({commit, dispatch, rootState, rootGetters}) {
    // Reset the submission response in the case where there was an error
    // and the form was resubmitted again.
    commit('RESET_SUBMISSION_RESPONSE');

    const data = getDataObject(rootState);
    const token = rootGetters.token;

    // Send to API
    api
      .saveSubmission(data, token)
      .then(res => {
        if (!(res.status >= 200 || res.status < 300)) {
          commit('SET_SUBMISSION_RESPONSE', res);
          return dispatch(
            'setError',
            {status: res.status, message: res.statusText},
            {root: true}
          );
        }
        // Save the submission state
        const {status, data} = res;
        commit('SET_SUBMISSION_RESPONSE', {status, data});

        // Clear the answers so that user can't accidentally submit twice.
        dispatch('clearAnswers');
      })
      .catch(err => {
        console.error('Error', err);
        const errObj = {status: err.status, message: err.statusText};
        commit('SET_SUBMISSION_RESPONSE', err);
        return dispatch('setError', errObj, {root: true});
      });
  },

  // Reset the answers so that user can't accidentally submit them again
  clearAnswers({dispatch}) {
    const options = {root: true};
    dispatch('contact/clearContact', null, options);
    dispatch('resident/clearIsResident', null, options);
    dispatch('ownership/clearOwnership', null, options);
    dispatch('proxy/clearProxyHolder', null, options);
    dispatch('proxy/clearProxyAbstainOption', null, options);
    dispatch('comms/clearComms', null, options);
    dispatch('questions/clearQuestions', null, options);
    dispatch('voter/clearVoter', null, options);
  }
};

const mutations = {
  // Set the response from server on submission
  SET_SUBMISSION_RESPONSE(state, response) {
    state.submissionResponse = response;
  },
  // Reset the submission response, used to resubmit the form on failure
  RESET_SUBMISSION_RESPONSE(state) {
    state.submissionResponse = {status: 0};
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/vuex/modules/done.js